export const TOAST_MESSAGE = 'TOAST_MESSAGE';
